// Review wall: sort, Show more, and the Write a review dialog (draft: the form isn't sent anywhere yet).
(function () {
  function init(root) {
    if (root.dataset.rwReady) return;
    root.dataset.rwReady = '1';
    var list = root.querySelector('[data-rw-list]');
    var more = root.querySelector('[data-rw-more]');
    var first = +root.dataset.show || 8;
    var shown = first;

    function render() {
      var cards = Array.prototype.slice.call(list.children);
      cards.forEach(function (c, i) { c.hidden = i >= shown; });
      more.hidden = shown >= cards.length;
    }
    function sort(mode) {
      var cards = Array.prototype.slice.call(list.children);
      cards.sort(function (a, b) {
        if (mode === 'photos') return (b.dataset.photo - a.dataset.photo) || (a.dataset.i - b.dataset.i);
        if (mode === 'high') return (b.dataset.stars - a.dataset.stars) || (a.dataset.i - b.dataset.i);
        if (mode === 'low') return (a.dataset.stars - b.dataset.stars) || (a.dataset.i - b.dataset.i);
        return a.dataset.i - b.dataset.i;
      });
      cards.forEach(function (c) { list.appendChild(c); });
      shown = first;
      render();
    }
    root.querySelector('[data-rw-sort]').addEventListener('change', function (e) { sort(e.target.value); });
    more.addEventListener('click', function () { shown += first; render(); });
    render();

    var dialog = root.querySelector('[data-rw-dialog]');
    var form = root.querySelector('[data-rw-form]');
    root.querySelector('[data-rw-write]').addEventListener('click', function () { dialog.showModal(); });
    root.querySelector('[data-rw-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      form.querySelector('[data-rw-done]').hidden = false;
      setTimeout(function () { dialog.close(); form.reset(); form.querySelector('[data-rw-done]').hidden = true; }, 2200);
    });
  }
  function all() { document.querySelectorAll('[data-rw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
